/* @flow */
import * as React from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import Moment from 'react-moment';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import ElectroCheckboxGroup from 'forms/components/inputs/ElectroCheckboxGroup/ElectroCheckboxGroup';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  asset: Object,
  form: TypeForm,
};

@translate()
@observer
export default class RequestAssetQuoteForm extends React.Component<*> {
  render(): React.Fragment {
    const { t, asset, form }: TypeProps = this.props;

    let details: Array<*> = [
      asset.owned && [
        t('general:trading_account'),
        `${asset.account.name} ${asset.account.number}`,
      ],
      [t('general:assets.labels.number'), asset.asset_number],
      [t('general:manufacturer'), asset.manufacturer],
      [t('general:model'), asset.model],
      [t('general:labels.serial_number'), asset.serial_number],
    ];

    if (!asset.owned) {
      details = [
        [t('general:trading_account'), `${asset.account.name} ${asset.account.number}`],
        [t('general:contracts.labels.number'), asset.contract.er_contract_number],
        [t('general:labels.po_number'), asset.contract.er_po_number],
        [
          t('general:labels.expected_end_date'),
          <Moment
            key="end_date"
            date={asset.contract.er_expected_end_date}
            format="MMMM DD, YYYY"
          />,
        ],
      ].concat(details);
    }

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:assets.labels.details')}
          >
            <ActionDrawerTable data={details} />
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={form.$('natureOfRequest').label}
          >
            <ElectroCheckboxGroup field={form.$('natureOfRequest.requestType')} />
          </ActionDrawerBlock>
          <ActionDrawerBlock gutters={true} heading={form.$('additionalInformation').label}>
            <p>
              <b>{t('general:messages.provide_more_details')}</b>
            </p>
            <ElectroTextField
              field={form.$('additionalInformation.quoteMessage')}
              props={{
                multiline: true,
                rows: 3,
              }}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.request_quote')} />
      </React.Fragment>
    );
  }
}
